import { Box, Button, Grid, IconButton, Paper } from "@material-ui/core";
import { Add, Close } from "@material-ui/icons";
import MaterialTable from "material-table";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { createBroadcast, getAllBroadcast, getBroadcastOption } from "../../../../api/broadcastMessageApi";
import FormAddBroad from "./components/FormAddBroad";
import { columnsTablePayBroadCast, optionTablesBroadcast } from "./helpers/broadcastOption";
import { useSelector } from "react-redux";

function Broad() {
    // ref
    const controllerRef = useRef(null);
    const tableRef = useRef(null);

    // global redux state
    const { thisMenuPermission } = useSelector(state => {
        const { menuPermission } = state?.menu;
        return {
            thisMenuPermission: menuPermission?.find(menu => menu?.path === window.location.pathname)?.permission,
        };
    });

    // component state
    const [isOpenModalAdd, setIsOpenModalAdd] = useState(false);
    const [tableOptions, setTableOptions] = useState(optionTablesBroadcast);
    const [option, setOption] = useState({ userMobile: [] });

    // fetch data
    const fetchData = useCallback(async query => {
        try {
            const queryParams = {
                page: query?.page + 1 || 1,
                limit: query?.pageSize || 10,
                search: query?.search || "",
                order: query?.orderBy?.field || "broadcastMasterId",
                direction: query?.orderBy?.field ? query?.orderDirection : "desc",
            };
            const res = await getAllBroadcast(queryParams, controllerRef.current?.signal);
            if (res) {
                setTableOptions(currentState => ({
                    ...currentState,
                    currentPage: query?.page,
                    pageSize: query?.pageSize || 10,
                    totalData: res?.pagination?.totalData || 0,
                    order: query?.orderBy?.field || "broadcastMasterId",
                    direction: query?.orderBy?.field ? query?.orderDirection : "desc",
                }));
                return {
                    data: res?.data || [],
                    page: query?.page || 0,
                    totalCount: res?.pagination?.totalData || 0,
                };
            }
            return {
                data: [],
                page: 0,
                totalCount: 0,
            };
        } catch (error) {
            console.dir(error);
            return {
                data: [],
                page: 0,
                totalCount: 0,
            };
        }
    }, []);

    // fetch broadcast option
    const fetchBroadcastOption = useCallback(async signal => {
        try {
            const broadcastOption = await getBroadcastOption(signal);
            if (broadcastOption) {
                setOption(currentState => ({
                    ...currentState,
                    userMobile: broadcastOption?.userMobileOption,
                }));
            }
        } catch (error) {
            console.dir(error);
        }
    }, []);

    // create broadcast logic
    const handleCreateBroadcast = useCallback(async query => {
        try {
            const createBody = {
                messageTitle: query?.message_title,
                messageBody: query?.message_body,
                linkUrl: query?.link_url,
                date: query?.broad_date,
            };

            if (query?.target_audience === "0" && query?.hnNumberArray?.length) {
                createBody.hnNumberArray = query?.hnNumberArray;
            }

            if (query?.target_audience === "1" && query?.userMobileIds?.length) {
                createBody.userMobileIds = query?.userMobileIds;
            }

            // Add Broadcast
            const isCreateDoctor = await createBroadcast({ ...createBody }, controllerRef.current?.signal);
            if (isCreateDoctor) {
                tableRef.current.onQueryChange();
                setIsOpenModalAdd(false);
            }
        } catch (error) {
            console.dir(error);
        }
    }, []);

    useEffect(() => {
        controllerRef.current = new AbortController();
        const init = async () => {
            try {
                await fetchBroadcastOption(controllerRef.current?.signal);
            } catch (error) {
                console.dir(error);
            }
        };
        init();
        // to avoid memory leaked.
        return () => {
            controllerRef.current.abort();
        };
    }, [fetchBroadcastOption]);

    return (
        <div>
            <Grid container spacing={3}>
                <Grid item xs={12} lg={7} className="mb-5 mb-lg-0">
                    <h1 className="t-text-primary text-center text-xl-left">Broadcast Message</h1>
                </Grid>
                {thisMenuPermission?.create && (
                    <Grid item xs={12} lg={5} className="mb-5 mb-lg-0">
                        <Grid container spacing={3} justify={"flex-end"}>
                            <Grid item xs={12} lg={5}>
                                <Button onClick={() => setIsOpenModalAdd(true)} className="btn t-btn-primary w-100">
                                    <Add className="mr-2" /> Add Broadcast
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                )}

                {/* data Table */}
                <Grid item xs={12}>
                    <Paper>
                        <Box className="t-table-custom p-lg-10 p-5">
                            <MaterialTable
                                components={{ Container: Box }}
                                tableRef={tableRef}
                                data={fetchData}
                                title={""}
                                columns={columnsTablePayBroadCast()}
                                options={tableOptions}
                            />
                        </Box>
                    </Paper>
                </Grid>

                <Grid item xs={12}>
                    {/* Modal Create Broad */}
                    <Modal show={isOpenModalAdd} size="lg" scrollable={true} onHide={() => setIsOpenModalAdd(false)}>
                        <Modal.Header>
                            <Modal.Title>Add Broadcast</Modal.Title>
                            <IconButton onClick={() => setIsOpenModalAdd(false)}>
                                <Close />
                            </IconButton>
                        </Modal.Header>
                        <Modal.Body>
                            <FormAddBroad
                                onCancel={() => setIsOpenModalAdd(false)}
                                onSubmit={handleCreateBroadcast}
                                userMobileOption={option?.userMobile}
                            />
                        </Modal.Body>
                    </Modal>
                </Grid>
            </Grid>
        </div>
    );
}

export default Broad;
